export const getTrueFromMapper = conditionMap => {
  // Loop over the object and return the first matching condition
  for (const [condition, headline] of Object.entries(conditionMap)) {
    if (condition === 'true') {
      return headline
    }
  }
}
